import React from "react";
import { processSilentRenew } from "redux-oidc";

const SilentRenew: React.FC = () => {
  processSilentRenew();
  return <></>;
};

export default SilentRenew;
